export const PASSWORD_TYPE = 'PasswordType';

export const TEXT_TYPE = 'TextType';

export const NUMBER_TYPE = 'NumberType';

export const TEL_TYPE = 'TelType';

export const EMAIL_TYPE = 'EmailType';

export const HIDDEN_TYPE = 'HiddenType';

export const DATE_TIME_TYPE = 'DateTimeType';

export const DATE_TYPE = 'DateType';

export const TEXTAREA_TYPE = 'TextareaType';

export const CHECKBOX_TYPE = 'CheckboxType';

export const CUSTOMER_FILE_TYPE = 'CustomerFileType';

export const QUOTE_LINE_TYPE = 'QuoteLineType';

export const COLLECTION_TYPE = 'CollectionType';

export const LIVE_COLLECTION_TYPE = 'LiveCollectionType';

export const CHOICE_TYPE = 'ChoiceType';

export const FILE_TYPE = 'FileType';

export const URL_TYPE = 'UrlType';

export const DISPLAY_FIELDS_TYPE = 'DisplayFieldsType';

export const NUMBER_COMPARE_TYPE = 'NumberCompareType';

export const DATE_COMPARE_TYPE = 'DateCompareType';


export function getHTMLTypeFromFieldType(fieldType) {
    switch (fieldType) {
        case TEXT_TYPE:
        case TEXTAREA_TYPE:
        case DATE_TYPE:
        case DATE_TIME_TYPE:
        case EMAIL_TYPE:
        case NUMBER_TYPE:
        case TEL_TYPE:
            return 'text';
        case CHECKBOX_TYPE:
            return 'checkbox';
        case FILE_TYPE:
        case CUSTOMER_FILE_TYPE:
            return 'file';
        case HIDDEN_TYPE:
            return 'hidden';
        case PASSWORD_TYPE:
            return 'password';
        default:
            return 'text';
    }
}
